import { useState, useCallback } from 'react';
import { getWithdrawData, setWithdrawData as setWithdrawStorage, putWithdrawData, removeWithdrawData as removeWithdrawStorage, clearWithdrawData } from 'app/libs/withdrawStorageUtils';
import useToken from 'app/hook/common/useToken';

export const WITHDRAW_KEYS = {
	USER_DETAIL: 'userDetail',
	TERMS_AGREED: 'termsAgreed',
	SNS_VERIFIED: 'snsVerified',
	SNS_VERIFY_RESULT: 'snsVerifyResult',
	SNS_VERIFIED_EXPIRED: 'snsVerifiedExpired',
	PHONE_VERIFIED: 'phoneVerified',
};

// withdraw_data가 다른 계정의 것으로 남아있지 않도록, 저장 데이터를 로그인 유저 id로 스코핑한다.
const OWNER_ID_KEY = 'ownerId';

function useWithdrawData() {
	const { getTokenPayload } = useToken();

	const getCurrentUserId = useCallback(() => {
		try {
			return getTokenPayload()?.user?.id;
		} catch (e) {
			return undefined;
		}
	}, [getTokenPayload]);

	const [withdrawData, setWithdrawData] = useState(() => {
		const stored = getWithdrawData();
		const currentUserId = getCurrentUserId();
		if (stored && currentUserId && stored[OWNER_ID_KEY] === currentUserId) return stored;
		clearWithdrawData();
		return {};
	});

	const updateWithdrawData = useCallback((key, data) => {
		putWithdrawData(key, data);
		setWithdrawData((prev) => ({ ...prev, [key]: data }));
	}, []);

	const removeWithdrawData = useCallback((key) => {
		removeWithdrawStorage(key);
		setWithdrawData((prev) => {
			const { [key]: _removed, ...rest } = prev;
			return rest;
		});
	}, []);

	const resetWithdrawData = useCallback(() => {
		const initial = { [OWNER_ID_KEY]: getCurrentUserId() };
		setWithdrawStorage(initial);
		setWithdrawData(initial);
	}, [getCurrentUserId]);

	const userDetail = withdrawData[WITHDRAW_KEYS.USER_DETAIL] || {};

	return {
		withdrawData,
		userDetail,
		updateWithdrawData,
		removeWithdrawData,
		resetWithdrawData,
	};
}

export default useWithdrawData;
